<template>
  <message-dialog :dialog="true" persistent :ok-button-loading="!ownedPaywallPlan" @ok="$emit('close')" @keydown.esc="$emit('close')">
    <template #content>
      <loading-indicator v-if="!ownedPaywallPlan" class="mt-2" />
      <div v-else class="d-flex flex-column">
        <h3 class="mb-2 font-weight-bold">{{ $translate("PaywallSuccessDialog.congratulations", { planTitle: ownedPaywallPlan.title || "Premium" }) }}</h3>
        <div>{{ $translate("PaywallSuccessDialog.toManageYourSubscription") }}</div>
      </div>
    </template>
    <template #ok>{{ $translate("common.gotIt") }}</template>
  </message-dialog>
</template>

<script>
import { mapState } from "pinia"

import { useUserSessionStore } from "@/store/userSession.js"

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState(useUserSessionStore, ["ownedPaywallPlan"])
  }
}
</script>
